import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Stack, Typography} from '@mui/material';
import {useRef} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {isMobile} from 'react-device-detect';
import DeleteIcon from "@mui/icons-material/Delete";
import {User} from "../../../interface/user.interface";
import {EmotionInterface} from "../../../interface/emotion.interface";
import {constance} from "../../../common/constance/constance";
import {styles} from "../../../common/style";

export default function EmotionDialog(props: { state: any, setState: any, emotionDetailList: EmotionInterface[] }) {
    console.log('[EmotionDialog]');

    const handleClose = () => {
        props.setState({
            ...props.state,
            openEmotionList: false,
        });
    };

    return (
        <div>
            <Dialog open={props.state.openEmotionList} onClose={handleClose} sx={{maxHeight: '100vh'}}>
                <DialogTitle>
                    <Box sx={{
                        display: 'flex', flexDirection: {xs: 'column', sm: 'column', md: 'row'},
                        width: 1, background: 'rgba(234,234,234,0.6)', p: 1.5, borderRadius: 2,
                    }}>
                        <Box sx={{display: 'flex', justifyContent: 'center', width: 1}}>
                            <Typography variant={'h6'}>
                                {`표정 ${props.emotionDetailList.length} 개`}
                            </Typography>
                        </Box>

                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Stack sx={{mt: 2, p: 1, }}>
                            {
                                props.emotionDetailList.map((emotionDetail: EmotionInterface, index: number) => {
                                    let emotion = constance.emotionList.find((emotion: any) => emotion.id == emotionDetail.id)
                                    return (
                                        <Box key={index}
                                             sx={{
                                                 display: 'flex', width: 1, justifyContent: 'flex-start',
                                                 alignItems: 'center',
                                                 p:1,
                                                 borderTop: index == 0? styles.border : '',
                                                 borderBottom: styles.border,
                                             }}>
                                            <Typography align={"left"} sx={{fontSize: 30, mr: 1}}>
                                                {emotion.value}
                                            </Typography>
                                            <Typography color={"black"}>
                                                {`${emotionDetail.user.departmentName} ${emotionDetail.user.name}`}
                                            </Typography>
                                        </Box>
                                    )
                                })
                            }
                        </Stack>
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Button variant={"outlined"} color={"neutral"} onClick={handleClose}>닫기</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}